import { makeStyles } from '@material-ui/core'

const common = (_theme) => ({
  display: 'block',
  color: 'black',
  maxWidth: 600,
  lineHeight: '1rem',
  transition: 'font-size 150ms ease',
  '&:visited': {
    color: 'black',
  },
})

export const useStyles = makeStyles(theme => ({
  criterionLink: {
    ...common(theme),
    marginLeft: '1rem',
    marginTop: '1rem',
    marginBottom: '0.25rem',
    fontSize: 14,
    fontWeight: 700,
    '&:hover': {
      fontSize: 15,
    },
  },
  indicatorLink: {
    ...common(theme),
    marginLeft: '3rem',
    marginBottom: '0.2rem',
    fontSize: 12,
    fontWeight: 600,
    '&:hover': {
      fontSize: 13,
    },
  }
}))
